import { EmailPessoaModel } from './email-pessoa.model';
import { TelefonePessoaModel } from './telefone-pessoa.model';
import { EnderecoSchemaCadastroModel } from './endereco-schema-cadastro.model';

export class EnderecoTelaModel {

  constructor(
    public enderecoSchemaCadastroModel?: EnderecoSchemaCadastroModel,
    public emailPessoaModel?: EmailPessoaModel,
    public telefonePessoaModel?: TelefonePessoaModel,
  ) {
    this.enderecoSchemaCadastroModel = new EnderecoSchemaCadastroModel;
    this.emailPessoaModel = new EmailPessoaModel;
    this.telefonePessoaModel = new TelefonePessoaModel;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/models/endereco-Tela.model.ts